import pt from '../../locales/pt';
import { formatGuidedFlowTemplate } from '../../utils/guidedFlowUtils';

export function formatAlertCopy(alert) {
  const efCopy = pt.emergencyFund?.alerts;
  const efFallback =
    alert.type === 'ef_expenses_above_target'
      ? { title: efCopy?.expensesAbove, message: '', badge: 'FE' }
      : alert.type === 'ef_below_target'
        ? { title: efCopy?.belowTarget, message: '', badge: 'FE' }
        : alert.type === 'ef_allocation_drift'
          ? { title: efCopy?.allocationDrift, message: '', badge: 'FE' }
          : alert.type === 'ef_review_allocations'
            ? { title: efCopy?.reviewAllocations, message: '', badge: 'FE' }
            : null;

  const templates = pt.dashboard.alerts.types[alert.type] || efFallback;
  if (!templates) return { title: '', message: '', badge: '' };
  const { meta = {} } = alert;
  const params = {
    category: meta.categoryName ?? '',
    count: meta.count ?? 0,
    group: meta.groupName ?? '',
    percent: meta.percent != null ? Math.round(Number(meta.percent)) : '',
    target: meta.targetPct != null ? Math.round(Number(meta.targetPct)) : '',
  };
  return {
    title: formatGuidedFlowTemplate(templates.title, params),
    message: formatGuidedFlowTemplate(templates.message, params),
    badge: templates.badge,
  };
}
